import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import _ from 'lodash'
import moment from 'moment'

import './style.scss'

export default class ParticipationHeader extends Component {
    static propTypes = {
        endYear: PropTypes.object.isRequired,
        startYear: PropTypes.object.isRequired,
        step: PropTypes.number.isRequired,
        translates: PropTypes.shape({
            today: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const {
            startYear,
            endYear,
            step,
            translates: { today },
        } = this.props

        const parsedStartYear = parseInt(startYear.format('YYYY'), 10)
        const parsedEndYear = parseInt(endYear.format('YYYY'), 10)

        const years = _.range(parsedStartYear, parsedEndYear + 1, step)

        const duration = endYear.diff(startYear, 'days')

        // Check if any role is active (continuing to current date)
        const active = moment(endYear).isSame(moment(), 'day')

        const yearElements = _.map(years, (year) => ({
            value: _.toString(year),
            // Margin to the left based on difference between value and timeline start year
            left: (moment(_.toString(year), 'YYYY').diff(startYear, 'days') / duration) * 100,
        }))

        // If any role is active -> set last element value as "today" text
        if (active) {
            yearElements.splice(yearElements.length - 1, 1, {
                value: today,
                left: 100,
            })
        }

        return (
            <div className={'role-table-line'}>
                {_.map(yearElements, (el, index) => (
                    <div
                        key={`year-label-${index}`}
                        className={cx('year-label', !active && 'historical')}
                        style={{ left: `${_.get(el, 'left', null)}%` }}
                    >
                        {_.get(el, 'value', '')}
                    </div>
                ))}
            </div>
        )
    }
}
